import React from 'react';
import {Link} from 'react-router-dom';
import {Col, Container, Row} from 'reactstrap';

// Import Images
import img2 from "../../assets/images/app/smartly2.png";
import img3 from "../../assets/images/app/smartly1.png";
import {useDispatch} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {appConfig} from '../../config';
import {toggleShowDemoRequest} from "../../store/requestDemo/slice";

const Features = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    return (
        <React.Fragment>
            <section className="py-5 bg-primary position-relative">
                <div className="bg-overlay bg-overlay-pattern opacity-50"></div>
                <Container>
                    <Row className="align-items-center gy-4">
                        <Col className="col-sm">
                            <div>
                                <h4 className="text-white mb-0 fw-semibold">{t('t-coorporate')}</h4>
                            </div>
                        </Col>
                        <Col className="col-sm-auto">
                            <div>
                                <Link to="" className="btn bg-gradient btn-danger" onClick={e => {
                                    e.preventDefault();
                                    dispatch(toggleShowDemoRequest());
                                }}>
                                    {t('t-use-demo')}
                                </Link>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="section" id="features">
                <Container>
                    <Row className="align-items-center gy-4">
                        <Col lg={5} sm={4} className="order-2 order-lg-1">
                            <div className="text-muted">
                                <h3 className="mb-3 fw-semibold">
                                    {t('t-automate-processes')}
                                </h3>
                                <p className="mb-4 ff-secondary">
                                    {t('t-get-rid-of-regular-work')}
                                </p>

                                <Row>
                                    <Col sm={12}>
                                        <div className="vstack gap-2">
                                            <div className="d-flex align-items-start">
                                                <div className="flex-shrink-0 me-2">
                                                    <div className="avatar-xs icon-effect">
                                                        <div
                                                            className="avatar-title bg-transparent text-success rounded-circle h2">
                                                            <i className="ri-team-line"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="flex-grow-1">
                                                    <h5 className="fs-14 mb-0 fw-semibold">
                                                        {t('t-advantages-hr')}
                                                    </h5>
                                                    <p>
                                                        {t('t-advantages-hr-desc').split('{appName}')[0]}
                                                        <span
                                                            className='text-secondary fw-semibold'>{appConfig.appName}</span>
                                                        {t('t-advantages-hr-desc').split('{appName}')[1]}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-start">
                                                <div className="flex-shrink-0 me-2">
                                                    <div className="avatar-xs icon-effect">
                                                        <div
                                                            className="avatar-title bg-transparent text-success rounded-circle h2">
                                                            <i className="las la-user-tie"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="flex-grow-1">
                                                    <h5 className="fs-14 mb-0 fw-semibold">
                                                        {t('t-advantages-bosses')}
                                                    </h5>
                                                    <p>
                                                        {t('t-advantages-bosses-desc')}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>

                        <Col lg={7} sm={8} className="col-10 ms-auto order-1 order-lg-2">
                            <div>
                                <img src={img2} alt="" className="img-fluid"/>
                            </div>
                        </Col>
                    </Row>

                    <Row className="align-items-center mt-5 pt-lg-5 gy-4">
                        <Col lg={6} sm={7} className="col-10 mx-auto">
                            <div>
                                <img src={img3} alt="" className="img-fluid"/>
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className="text-muted ps-lg-5">
                                <h5 className="fs-12 text-uppercase text-success">{t('t-structure')}</h5>
                                <h4 className="mb-3">{t('t-comfor-design')}</h4>
                                <p className="mb-4">{t('t-comfort-design-desc')}</p>

                                <div className="vstack gap-2">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-shrink-0 me-2">
                                            <div className="avatar-xs icon-effect">
                                                <div
                                                    className="avatar-title bg-transparent text-success rounded-circle h2">
                                                    <i className="ri-check-fill"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1">
                                            <p className="mb-0">{t('t-comfort-design-child1')}</p>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <div className="flex-shrink-0 me-2">
                                            <div className="avatar-xs icon-effect">
                                                <div
                                                    className="avatar-title bg-transparent text-success rounded-circle h2">
                                                    <i className="ri-check-fill"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1">
                                            <p className="mb-0">{t('t-comfort-design-child2')}</p>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <div className="flex-shrink-0 me-2">
                                            <div className="avatar-xs icon-effect">
                                                <div
                                                    className="avatar-title bg-transparent text-success rounded-circle h2">
                                                    <i className="ri-check-fill"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1">
                                            <p className="mb-0">{t('t-comfort-design-child3')}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default Features;